import { DependenciesInjection } from "app/di/DependencyInjection";
import { DiscountManagementImpl } from "../data/DiscountManagementImpl";
import { IDiscountManagementRepository } from "../domain/repositories/IDiscountManagementRepository";
import { DiscountManagementUseCase } from "../domain/useCases/DiscountManagementUseCase";
import { DiscountManagementToken } from "./DiscountManagementToken";
import { DiscountManagementViewModel } from "../presentation/viewModel/DiscountManagementViewModel";

export class DiscountManagementInjection {
  static initInjection() {
    DependenciesInjection.register<IDiscountManagementRepository>(
      DiscountManagementToken.IDiscountManagementRepository,
      DiscountManagementImpl,
      "otherRepo",
    );
    DependenciesInjection.register<DiscountManagementUseCase>(
      DiscountManagementToken.DiscountManagementUseCase,
      DiscountManagementUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<DiscountManagementViewModel>(
      DiscountManagementToken.DiscountManagementViewModel,
      DiscountManagementViewModel,
      "viewModel",
    );
  }

  static getDiscountManagementRepo() {
    return DependenciesInjection.getRepo<IDiscountManagementRepository>(
      DiscountManagementToken.IDiscountManagementRepository,
    );
  }

  static getDiscountManagementUseCase() {
    return DependenciesInjection.getRepo<DiscountManagementUseCase>(
      DiscountManagementToken.DiscountManagementUseCase,
    );
  }

  static getDiscountManagementViewModel() {
    return DependenciesInjection.getRepo<DiscountManagementViewModel>(
      DiscountManagementToken.DiscountManagementViewModel,
    );
  }
}
